module.exports = __webpack_public_path__ + "img/antes_despues_281.c7a7de35.png";